import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import UseAuth from "../utils/use-auth";
import {
  FiSettings,
  FiLogOut,
  FiChevronDown,
  FiChevronUp,
  FiMenu,
  FiX,
} from "react-icons/fi";
import { FaPlus } from "react-icons/fa6";
import { BsFillClockFill } from "react-icons/bs";
import { RiUserFill } from "react-icons/ri";
import FullLogo from "../assets/Full logo.png";
import { featuresData } from "../utils/features-data";

const Sidebar = ({ conversations, handleSelectConversation }) => {
  const [isAgents, setIsAgents] = useState(false);
  const [selectedAgentIndex, setSelectedAgentIndex] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const { HandleUserLogOut } = UseAuth();

  return (
    <>
      {/* Mobile hamburger */}
      <div className="lg:hidden fixed top-4 left-4 z-50">
        <button
          onClick={() => setIsOpen(true)}
          className="p-2 rounded-lg bg-[#1B2B5E] text-white shadow-lg border border-white/10"
        >
          <FiMenu className="text-xl" />
        </button>
      </div>

      {/* Mobile overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/60 backdrop-blur-sm z-40 lg:hidden"
          onClick={() => setIsOpen(false)}
        />
      )}

      {/* Sidebar — fixed height flex column, never lets content overflow */}
      <div
        className={`
          fixed top-0 left-0 h-screen bg-[#111d42] border-r border-white/10
          w-[240px] z-50 flex flex-col
          transform transition-transform duration-300 ease-in-out
          ${isOpen ? "translate-x-0" : "-translate-x-full"}
          lg:translate-x-0 lg:static lg:flex-none
        `}
      >
        {/* ── Logo ── fixed */}
        <div className="flex items-center justify-between px-5 pt-6 pb-4 border-b border-white/10 flex-shrink-0">
          <img
            className="h-9 object-contain cursor-pointer"
            src={FullLogo}
            alt="Martech Mastery"
            onClick={() => { navigate("/"); setIsOpen(false); }}
          />
          <button
            className="lg:hidden text-white/40 hover:text-white transition-colors"
            onClick={() => setIsOpen(false)}
          >
            <FiX className="text-lg" />
          </button>
        </div>

        {/* ── New Chat ── fixed */}
        <div className="px-4 pt-4 pb-2 flex-shrink-0">
          <button
            className="flex items-center justify-center gap-2 w-full px-4 py-2.5 text-white bg-[#F05A22] rounded-xl font-semibold text-sm hover:bg-[#c8471a] transition-all"
            onClick={() => { handleSelectConversation(null); setIsOpen(false); }}
          >
            <FaPlus className="text-sm" />
            New Chat
          </button>
        </div>

        {/* ── Agents toggle ── fixed */}
        <div className="px-4 flex-shrink-0">
          <button
            className="flex items-center gap-3 w-full px-3 py-2.5 text-white/70 hover:text-white hover:bg-white/10 rounded-lg transition-all font-medium text-sm"
            onClick={() => setIsAgents(!isAgents)}
          >
            <RiUserFill className="text-[#F05A22] text-base flex-shrink-0" />
            <span>Agents</span>
            {isAgents
              ? <FiChevronUp className="ml-auto text-white/40" />
              : <FiChevronDown className="ml-auto text-white/40" />}
          </button>

          {isAgents && (
            <div className="ml-4 border-l border-white/10 pl-3 flex flex-col gap-0.5 mt-1 mb-1">
              {featuresData?.map((item, index) => (
                <div
                  key={item?.title}
                  className={`text-sm px-3 py-2 rounded-lg cursor-pointer transition-all truncate ${
                    selectedAgentIndex === index
                      ? "bg-[#F05A22]/20 text-[#F05A22] font-semibold"
                      : "text-white/60 hover:bg-white/10 hover:text-white"
                  }`}
                  onClick={() => {
                    setSelectedAgentIndex(index);
                    navigate(item?.link);
                    setIsOpen(false);
                  }}
                >
                  {item?.title}
                </div>
              ))}
            </div>
          )}
        </div>

        {/* ── My History label ── fixed */}
        <div className="px-4 mt-2 flex-shrink-0">
          <div className="flex items-center gap-3 px-3 py-2 text-white/70 font-medium text-sm">
            <BsFillClockFill className="text-[#7B4FBF] text-base flex-shrink-0" />
            <span>My History</span>
          </div>
        </div>

        {/* ── Conversation list ── flex-1 so it fills remaining height and scrolls */}
        <div className="flex-1 min-h-0 overflow-y-auto px-4 pb-2">
          {conversations?.data?.length > 0 ? (
            <div className="flex flex-col gap-0.5">
              {conversations.data.map((item) => (
                <div
                  key={item?.id}
                  className="text-sm text-white/50 px-3 py-2 rounded-lg hover:bg-white/10 hover:text-white cursor-pointer truncate transition-all"
                  onClick={() => { handleSelectConversation(item); setIsOpen(false); }}
                >
                  {item?.name}
                </div>
              ))}
            </div>
          ) : (
            <p className="text-xs text-white/25 px-3 py-2 italic">No conversations yet.</p>
          )}
        </div>

        {/* ── Bottom actions ── fixed */}
        <div className="px-4 py-4 border-t border-white/10 flex flex-col gap-1 flex-shrink-0">
          <button
            className="flex items-center gap-3 w-full px-3 py-2.5 text-white/70 hover:text-white hover:bg-white/10 rounded-lg transition-all font-medium text-sm"
            onClick={() => navigate("/settings")}
          >
            <FiSettings className="text-[#F05A22] text-base flex-shrink-0" />
            Settings
          </button>
          <button
            className="flex items-center gap-3 w-full px-3 py-2.5 text-red-400 hover:text-red-300 hover:bg-red-500/10 rounded-lg transition-all font-medium text-sm"
            onClick={HandleUserLogOut}
          >
            <FiLogOut className="text-base flex-shrink-0" />
            Log Out
          </button>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
